// utils
import * as methods from '@utils/methods';

import { DELETE, GET, POST, PUT } from '../request';

/**
 * fetch fingers list
 * @param {*} payload
 */
export async function fetchFingersList(payload) {
  const params = methods.convertQueryString(payload);
  return GET(`fingers?${params}`);
}

/**
 * get fingers
 * @param {*} payload
 */

export async function fetchFingers(payload) {
  return GET(`fingers/${payload}`);
}

/**
 * update fingers by id
 * @param {*} payload
 */
export async function updateFingersById(payload) {
  const { id, ...rest } = payload;
  return PUT(`fingers/${id}`, rest);
}

/**
 * remove fingers by id
 * @param {*} payload
 */
export async function removeFingersById(payload) {
  return DELETE(`fingers/${payload}`);
}

/**
 * create fingers
 * @param {*} payload
 */
export async function createFingers(payload) {
  return POST(`fingers`, payload);
}
